import { GenotypingDto, CreateGenotypingDto, UpdateGenotypingDto } from 'src/dto/genotyping.dto'
import { API } from '../config'
import { AxiosResponse } from 'axios'

const BASE_URL = '/entity/Genotipagem'

export class GenotypingService {
  public async getGenotypingListByFarmId(farmId: string): Promise<AxiosResponse<GenotypingDto[]>> {
    return await API.get(`${BASE_URL}/${farmId}/null`)
  }

  public async createGenotyping(createGenotypingDto: CreateGenotypingDto): Promise<AxiosResponse<GenotypingDto>> {
    const { idFazenda } = createGenotypingDto
    return await API.put(`${BASE_URL}/${idFazenda}`, createGenotypingDto)
  }

  public async updateGenotyping(updateGenotypingDto: UpdateGenotypingDto): Promise<AxiosResponse<GenotypingDto>> {
    const { idFazenda } = updateGenotypingDto
    return await API.put(`${BASE_URL}/${idFazenda}`, updateGenotypingDto)
  }

  public async deleteGenotyping(id: string): Promise<AxiosResponse<void>> {
    return await API.delete(`${BASE_URL}/${id}`)
  }
}
